import { styled, Button, InputLabel, Box, Theme, createStyles, makeStyles } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const {
  DARK_CONTAINER_FIELDS_FLOATING,
  DARK_FIELDS_ON_CARD_MENU,
  LIGHT_BACKGROUND,
  LIGHT_CONTAINER_BORDER,
  LIGHT_CONTAINER,
  LIGHT_MENUITEM_BACKGROUND,
  LIGHT_SLIDER_THUMB,
  PRIMARY_BUTTON_BORDER,
  PRIMARY_MENUITEM_BACKGROUND,
} = COLORS;
import { RangeSlider } from './RangeSlider';

export const MainCont = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  margin: '0 0 20px 0',
  padding: 25,
  backgroundColor: theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_FLOATING : LIGHT_CONTAINER,
  borderRadius: 8,
}));

export const CustomInputLabel = styled(InputLabel)(({ theme }) => ({
  fontSize: 13,
}));

export const SectionContainer = styled('div')(({ theme }) => ({
  marginTop: 20,
}));

export const Row = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: 15,
  [theme.breakpoints.down('xs')]: {
    flexDirection: 'column',
  },
}));

export const DoBContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: 10,

  '& > div': {
    maxWidth: 185,
  },

  [theme.breakpoints.down(960)]: {
    flexDirection: 'column',
  },
}));

export const CustomButton = styled(Button)(({ theme }) => ({
  height: 50,
  border: '1px solid',
  borderColor: PRIMARY_BUTTON_BORDER,
  borderRadius: 5,
  marginTop: 10,
  backgroundColor: 'transparent',
}));

export const StyledRangeSlider = styled(RangeSlider)(({ theme }) => ({
  '& span.MuiSlider-thumb:nth-of-type(1)': {
    background: 'red',
  },

  thumb: {
    height: 27,
    width: 27,
    backgroundColor: LIGHT_SLIDER_THUMB,
    border: '1px solid currentColor',
    marginTop: -12,
    marginLeft: -13,
    boxShadow: `${LIGHT_SLIDER_THUMB}0 2px 2px`,
    '&:focus, &:hover, &$active': {
      boxShadow: `${LIGHT_SLIDER_THUMB}0 2px 3px 1px`,
    },
    '& .bar': {
      // display: inline-block !important;
      height: 9,
      width: 10,
      backgroundColor: 'currentColor',
      marginLeft: 1,
      marginRight: 1,
    },
  },
}));

export const AdultSliderCont = styled(Box)<Theme, { slim?: boolean; keepRanged?: boolean }>(
  ({ theme, slim, keepRanged }) => ({
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 60,
    ...(slim && {
      height: 500,
      width: '100%',
      justifyContent: 'space-around',
      alignItems: 'center',
      flexDirection: 'row',
      marginBottom: 0,
    }),
    [theme.breakpoints.down(960)]: {
      ...(!keepRanged && {
        height: 500,
        width: '100%',
        justifyContent: 'space-around',
        alignItems: 'center',
        flexDirection: 'row',
      }),
    },
  }),
);

export const PlayingAgeCont = styled(Box)(({ theme }) => ({
  display: 'flex',
  marginBottom: 20,
  [theme.breakpoints.down(960)]: {
    flexDirection: 'column',
  },
}));

export const Rail = styled('div')(({ theme }) => ({
  position: 'relative',
  width: '100%',
  height: 20,
}));

export const MiddleThumb = styled('span')(({ theme }) => ({
  backgroundColor: 'red',
}));

export const ParentThumb = styled(Box)<Theme, { middle: boolean }>(({ theme, middle }) => ({
  height: middle ? 16 : 25,
  marginTop: middle ? 0 : '',
  width: middle ? 20 : '',
  backgroundImage: middle ? `url('/assets/three-horizontal-lines-icon.png')` : '',
  backgroundSize: '100% 60%',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  border: middle ? 'none' : '1px solid white',
  cursor: middle ? 'ew-resize' : 'grab',
  [theme.breakpoints.down(960)]: {
    backgroundImage: 'unset',
  },
}));

export const InstructionCont = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_FLOATING : LIGHT_CONTAINER,
  padding: '10px 20px',
  display: 'flex',
  alignItems: 'center',
  borderRadius: 8,
  border:
    theme.palette.type === 'dark' ? `1px dashed ${LIGHT_CONTAINER_BORDER}` : `1px dashed ${LIGHT_CONTAINER_BORDER}`,
  margin: '26px 0',
  maxWidth: 865,
  wordBreak: 'break-word',
}));

export const FlexContainer = styled('div')<Theme, { $gap?: number }>(({ $gap = 0, theme }) => ({
  marginTop: 20,
  display: 'flex',
  alignItems: 'center',
  gap: $gap,
  [theme.breakpoints.down(960)]: {
    flexDirection: 'column',
  },
}));

export const SaveButton = styled(Button)(({ theme }) => ({
  height: '50px !important',
  textTransform: 'unset',
  textDecoration: 'none!important',
  width: 311,
  [theme.breakpoints.down('xs')]: {
    width: '100%',
  },
}));

export const useStyles = makeStyles((theme) =>
  createStyles({
    inputRoot: {
      backgroundColor: theme.palette.type === 'dark' ? `${DARK_FIELDS_ON_CARD_MENU} !important` : LIGHT_BACKGROUND,
      borderRadius: 4,
    },
    option: {
      '&:hover': {
        backgroundColor:
          theme.palette.type === 'dark' ? `${PRIMARY_MENUITEM_BACKGROUND} !important` : LIGHT_MENUITEM_BACKGROUND,
      },
      '&[data-focus="true"]': {
        backgroundColor: theme.palette.type === 'dark' ? '' : LIGHT_MENUITEM_BACKGROUND,
      },
    },
    select: {
      backgroundColor:
        theme.palette.type === 'dark' ? `${DARK_FIELDS_ON_CARD_MENU} !important` : LIGHT_MENUITEM_BACKGROUND,
    },
  }),
);
